import { MESSAGES, PATH } from 'src/components/constants';
import { store } from 'src/utils/store';
import { ModuleEnum } from 'src/generated/operations';
import { h } from '@stencil/core';
import { createClickHandler } from 'src/components/functional/createClickHandler';

export const RenderFireAndSmokeFork = () => [
    (
        <div class="page page--filter">
            <div class="page__breadcrumbs">
                <app-breadcrumbs links={[]}>
                    <belimo-i18n messageId={ModuleEnum.FireAndSmoke}/>
                </app-breadcrumbs>
            </div>

            <div class="page__content">
                <div class="fire-and-smoke-fork">
                    <h2 class="fire-and-smoke-fork__title">
                        <belimo-i18n messageId={MESSAGES.FIRE_AND_SMOKE_SELECT_TYPE}/>
                    </h2>

                    <div class="selection">
                        <div class="fire-and-smoke-fork__cards">
                            <div class="selection-box__slot">
                                <stencil-route-link url={`${store.state.root}${PATH.FILTER}/${ModuleEnum.FireAndSmoke}/1`}
                                                    onClick={createClickHandler(ModuleEnum.FireAndSmoke)}
                                                    class="selection-item selection-item--big fire-and-smoke-fork__selection-item">
                                    <div class="selection-item__title">
                                        <h2>
                                            <belimo-i18n messageId={MESSAGES.FIRE_AND_SMOKE_ELECTRONIC}/>
                                        </h2>
                                        <p>
                                            <belimo-i18n messageId={MESSAGES.FIRE_AND_SMOKE_ELECTRONIC_DESCRIPTION}/>
                                        </p>
                                    </div>
                                    <div class="selection-item__icon">
                                        <belimo-svg-sprite svgId={'delimiter'}/>
                                    </div>
                                </stencil-route-link>
                            </div>
                            <div class="selection-box__slot">
                                <stencil-route-link url={`${store.state.root}${PATH.FILTER}/${ModuleEnum.FireAndSmokeSolution}/1`}
                                                    onClick={createClickHandler(ModuleEnum.FireAndSmokeSolution)}
                                                    class="selection-item selection-item--big fire-and-smoke-fork__selection-item">
                                    <div class="selection-item__title">
                                        <h2>
                                            <belimo-i18n messageId={MESSAGES.FIRE_AND_SMOKE_PNEUMATIC}/>
                                        </h2>
                                        <p>
                                            <belimo-i18n messageId={MESSAGES.FIRE_AND_SMOKE_PNEUMATIC_DESCRIPTION}/>
                                        </p>
                                    </div>
                                    <div class="selection-item__icon">
                                        <belimo-svg-sprite svgId={'delimiter'}/>
                                    </div>
                                </stencil-route-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
];
